import { useMemo } from 'react';
import { useSearchParams } from 'next/navigation';
import { useOrdersContext } from '@/context/OrdersContext';

export function useIsHired(serviceId: string | undefined, userId?: string) {
    const { orders } = useOrdersContext();
    const searchParams = useSearchParams();
    const workspaceId = searchParams?.get('workspaceId') || undefined;

    const hiredOrder = useMemo(() => {
        if (!serviceId) return undefined;
        // Strict filtering: Find order for this service, buyer, and active workspace.
        return orders.find(o =>
            o.serviceId === serviceId &&
            (!userId || o.buyerId === userId) &&
            (!workspaceId || (o.workspaceId || o.workspace?.id) === workspaceId)
        );
    }, [orders, serviceId, userId, workspaceId]);


    const isHired = useMemo(() => {
        return !!hiredOrder && searchParams?.get('source') !== 'marketplace';
    }, [hiredOrder, searchParams]);

    return { isHired, hiredOrder };
}
